import { useMap, Polygon } from "react-leaflet";
import L, { LatLngExpression } from "leaflet";
import React, { useEffect, useState } from "react";
import Boundary from "models/geospatial/boundary";
import "leaflet/dist/leaflet.css";
import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
import "leaflet-extra-markers";
import ExtraContent from "../extra-content";

const BoundaryLeaflet = ({ boundary }: { boundary: Boundary }) => {
  const map = useMap();
  const [latLngs, setLatLngs] = useState<any[]>([]);
  useEffect(() => {
    if (boundary.geom && map) {
      const newLatLngs = L.GeoJSON.coordsToLatLngs(
        boundary.geom.coordinates,
        2,
      );
      setLatLngs(newLatLngs);
      map.fitBounds(newLatLngs);
    }
  }, [map, boundary]);
  return (
    <Polygon
      positions={
        latLngs as
          | LatLngExpression[]
          | LatLngExpression[][]
          | LatLngExpression[][][]
      }
    >
      <ExtraContent info={{ ...boundary }} />
    </Polygon>
  );
};

export default BoundaryLeaflet;
